module.exports = Backbone.Model.extend({
    defaults: {
        enabled: false,
    },
});
